import { GeoJsonLayer } from "@deck.gl/layers";
// @ts-expect-error: DeckGL doesnt expose MaskExtension type correctly
import { MaskExtension } from '@deck.gl/extensions';
import OCEAN from './ocean.json';

const OCEAN_MASK_ID = "ocean-mask";

function getOceanMaskLayer() {
  return new GeoJsonLayer({
    id: OCEAN_MASK_ID,
    data: OCEAN,
    operation: 'mask'
  });
}

function applyOceanMask() {
  return {
    extensions: [new MaskExtension()],
    maskId: OCEAN_MASK_ID
  }
}

export const OceanMask = {
  applyOceanMask,
  getOceanMaskLayer,
}
